import { useCallback, useEffect, useRef, useState } from "react";

import SPfetch from "@services/SPFetch.class";
import { ResourceSliderItemType } from "@types";

type UseResourcesSliderType = Array<Record<string, any>>;

export const useResourcesSlider = (
  data: UseResourcesSliderType
): Array<ResourceSliderItemType> => {
  const firstRender = useRef(true);
  const [sliderPosts, setSliderPosts] = useState<Array<ResourceSliderItemType>>(
    []
  );

  const getResourceSlider = useCallback(async (item: Record<string, any>) => {
    if (!item?.id) return null;
    const url = `https://cdn.builder.io/api/v3/content/page-resource-post?apiKey=${process.env.GATSBY_BUILDER_API_KEY}&query.id=${item?.id}`;

    const res = await SPfetch.get(url);

    return res;
  }, []);

  const formatResourcesPost = (data: Record<string, any>) => {
    if (!data) return {} as ResourceSliderItemType;

    const breakType: string = data?.type.toLowerCase().split(" ").join("-");
    const post: ResourceSliderItemType = {
      resourcesC: {
        resourceType: data?.type,
        resourcesCardsImage: {
          altText: "Resource Post",
          mediaItemUrl: data?.cardImage,
          builderImage: true,
          localFile: null,
        },
        resourcesCardsLink: data?.url,
        resourceCustomTitle: data?.articleTitle,
      },
      slug: data?.url,
      title: data?.title,
      uri: data?.url,
      resourcesCategories: {
        nodes: [
          {
            name: breakType,
          },
        ],
      },
    };

    return post;
  };

  const getResourcesSlider = useCallback(
    async (data: UseResourcesSliderType) => {
      if (typeof data === "undefined") return [];

      const res = await Promise.all(
        data.map(item => getResourceSlider(item?.resource))
      );

      if (!res || res.length <= 0) return [];

      return res.map(item => formatResourcesPost(item?.results[0].data));
    },
    [getResourceSlider]
  );

  useEffect(() => {
    if (firstRender.current) {
      getResourcesSlider(data).then(res => {
        if (res && res.length > 0) {
          setSliderPosts(res);
          return;
        }
      });

      firstRender.current = false;
    }
  }, [data, getResourcesSlider]);

  return sliderPosts;
};
